<p-dialog (visibleChange)="toggleVisible($event)" [(visible)]="visible" appendTo="body"
          [modal]="true"
          [style]="{ width: '450px' }">
  <ng-template pTemplate="header">
    <div class="title-popup"><span class="p-dialog-title">{{ config.title | translate }}</span></div>
  </ng-template>
  <ng-template pTemplate="content">
    <span class="p-confirm-dialog-message" [innerHTML]="config.message | translate"></span>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button styleClass="btn-yellow" icon="pi pi-times" iconPos="right" (click)="confirm(false)"
              label="Đóng"></p-button>
    <p-button icon="pi pi-check" styleClass="btn-blue" iconPos="right" (click)="confirm(true)"
              label="Chấp nhận"></p-button>
  </ng-template>
</p-dialog>

